import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { some, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { obj_type, option_type, anonRecord_type, list_type, int32_type, string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { InvoiceeFileType, InvoiceeFileTypeModule_toInt, NumbersForContract$reflection } from "./Common.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { File$reflection } from "./Model.js";

export function loadActivePhoneNumbers(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, `/Invoicee/ActivePhoneNumbers/${clientNr}/`));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(NumbersForContract$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(NumbersForContract$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(anonRecord_type(["ContractNrs", list_type(int32_type)])), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function loadFiles(clientNr, invoiceeNr) {
    let arg_2;
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, (arg_2 = (InvoiceeFileTypeModule_toInt(new InvoiceeFileType(1)) | 0), toText(printf("/contract/%i/%i/generalInvoiceeFiles/%i"))(clientNr)(invoiceeNr)(arg_2))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(File$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(File$reflection()), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(File$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function deleteFile(clientNr, invoiceeNr, invoiceeFileType, internalFilename) {
    let arg_3;
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, (arg_3 = (InvoiceeFileTypeModule_toInt(invoiceeFileType) | 0), toText(printf("/contract/%i/%i/invoiceeFilesByInternalFilename/%s/?FileType=%i"))(clientNr)(invoiceeNr)(internalFilename)(arg_3))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_4, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(void 0));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function deleteInvoicee(clientNr, invoiceeNr, isAdminUser) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, isAdminUser ? (`/invoicee/${clientNr}/${invoiceeNr}/?force=true`) : (`/invoicee/${clientNr}/${invoiceeNr}/`)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

